import React, { useEffect, useState } from 'react'
import { Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@material-ui/core'
import { Page, Header } from 'components'
import useRouter from 'utils/useRouter'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { useVeiculoService } from 'hooks/useVeiculoService'
import { useVestigioService } from 'hooks/useVestigioService'
import { getLabelEndereco } from 'helpers/labels'
import { CardCaso } from 'components/Cards/CardCaso'
import { CardExameSolicitado } from 'components/Cards/CardExameSolicitado'
import { CardVestigio } from 'components/Cards/CardVestigio'
import { ExibirArquivo } from 'components/ExibirArquivo'
import { MenuAcoes } from './components/MenuAcoes'
import useStyles from './styles'
import { useParams } from 'react-router'

export const Veiculo = (props) => {
  const { route } = props
  const router = useRouter()
  const params = useParams()
  const classes = useStyles()
  moment.locale('pt-br', localization)
  const veiculoService = useVeiculoService()
  const vestigioService = useVestigioService()
  const [veiculo, setVeiculo] = useState(null)
  const [vestigiosExtraidos, setVestigiosExtraidos] = useState(null)
  const [processandoVeiculo, setProcessandoVeiculo] = useState(false)

  useEffect(() => {
    const fetchVeiculoDetalhado = async () => {
      const result = await veiculoService.listarVeiculoDetalhadoAsync(params.id, setProcessandoVeiculo)
      setVeiculo(result)
    }

    fetchVeiculoDetalhado()
  }, [params.id])

  useEffect(() => {
    const fetchVestigiosExtraidos = async () => {
      const response = await vestigioService.listarVestigiosExtraidosDeVeiculoAsync(veiculo.id, setProcessandoVeiculo)
      setVestigiosExtraidos(response)
    }

    if (veiculo && veiculo.id) {
      fetchVestigiosExtraidos()
    }
  }, [veiculo])

  const handleClickCaso = (id, novaAba) => {
    if (novaAba) {
      window.open(`/casos/caso/detalhar/${id}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/casos/caso/detalhar/${id}`)
    }
  }

  const handleClickExameSolicitado = (id) => {
    router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${id}`)
  }

  const handleClickVestigio = (id) => {
    router.history.push(`/casos/caso/vestigio/detalhar/${id}`)
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      {processandoVeiculo || !veiculo ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div>
          <Card className={classes.results}>
            <CardContent>
              <div>
                <Grid alignItems="flex-end" container justifyContent="space-between" spacing={3}>
                  <Grid item>
                    <Typography className={classes.pageTitle}>
                      <b>INFORMAÇÕES SOBRE O VEÍCULO</b>
                    </Typography>
                  </Grid>
                  <Grid item>
                    <MenuAcoes idVeiculo={params.id} />
                  </Grid>
                </Grid>
              </div>
              <Divider />
              <Grid className={classes.item} item md={6} sm={6} xs={12}>
                <Typography variant="h6">
                  <b>Identificador</b>
                </Typography>
                <Typography> {veiculo.identificador || '-'} </Typography>
              </Grid>
              <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between">
                <Typography className={classes.titleCampo}>
                  <b>DADOS DE ENTRADA</b>
                </Typography>
                <Grid item md={12} sm={12} xs={12} style={{ padding: '1px' }}>
                  <Divider />
                </Grid>
                <Grid className={classes.item} item md={6} sm={6} xs={12}>
                  <Typography variant="h6">
                    <b>Placa</b>
                  </Typography>
                  <Typography> {veiculo.placa ? veiculo.placa : 'Não Informado'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={6} sm={6} xs={12}>
                  <Typography variant="h6">
                    <b>Data de entrada</b>
                  </Typography>
                  <Typography> {moment(veiculo.createdAt).format('LLLL')} </Typography>
                </Grid>
                <Grid className={classes.item} item md={6} sm={6} xs={12}>
                  <Typography variant="h6">
                    <b>Marca</b>
                  </Typography>
                  <Typography> {veiculo.marca ? veiculo.marca : 'Não Informado'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={6} sm={6} xs={12}>
                  <Typography variant="h6">
                    <b>Modelo</b>
                  </Typography>
                  <Typography> {veiculo.modelo ? veiculo.modelo : 'Não Informado'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={6} sm={6} xs={12}>
                  <Typography variant="h6">
                    <b>Descrição</b>
                  </Typography>
                  <Typography> {veiculo.descricao ? veiculo.descricao : 'Não Informado'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={6} sm={6} xs={12}>
                  <Typography variant="h6">
                    <b>Local associado</b>
                  </Typography>
                  <Typography>{veiculo.endOrig ? getLabelEndereco(veiculo.endOrig) : 'Nenhum local associado'} </Typography>
                </Grid>
              </Grid>
              <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between">
                <Typography className={classes.titleCampo}>
                  <b>CASOS RELACIONADOS</b>
                </Typography>
                <Grid item md={12} sm={12} xs={12} style={{ padding: '1px' }}>
                  <Divider />
                </Grid>
                <Grid className={classes.fieldGroup} alignItems="flex-start" container style={{ marginTop: '10px', marginRight: '20px' }}>
                  {veiculo.casos.length > 0 &&
                    veiculo.casos.map((caso) => (
                      <Grid item md={3} sm={9} xs={12} style={{ marginTop: '10px', marginRight: '20px', display: 'flex', gap: 20 }}>
                        <CardCaso caso={caso} handleClick={handleClickCaso} />
                      </Grid>
                    ))}
                </Grid>
              </Grid>

              <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between">
                <Typography className={classes.titleCampo}>
                  <b>EXAMES SOLICITADOS</b>
                </Typography>
                <Grid item md={12} sm={12} xs={12} style={{ padding: '1px' }}>
                  <Divider />
                </Grid>
                {veiculo.exSols && veiculo.exSols.length ? (
                  <Grid className={classes.fieldGroup} alignItems="flex-start" container style={{ marginTop: '10px', marginRight: '20px' }}>
                    {veiculo.exSols.map((exameSolicitado) => (
                      <Grid item md={3} sm={9} xs={12} style={{ marginTop: '10px', marginRight: '20px' }}>
                        <CardExameSolicitado exameSolicitado={exameSolicitado} handleClick={handleClickExameSolicitado} />
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Grid container justifyContent="center" alignItems="center" style={{ padding: '50px' }}>
                    <Typography>Nenhum exame solicitado</Typography>
                  </Grid>
                )}
              </Grid>

              <Grid className={classes.fieldGroup} alignItems="center" container justify="space-between">
                <Typography className={classes.titleCampo}>
                  <b>VESTÍGIOS EXTRAÍDOS</b>
                </Typography>
                <Grid item md={12} sm={12} xs={12}>
                  <Divider />
                </Grid>
                {vestigiosExtraidos && vestigiosExtraidos.length ? (
                  <Grid className={classes.fieldGroup} alignItems="flex-start" container style={{ marginTop: '10px', marginRight: '20px' }}>
                    {vestigiosExtraidos.map((vestigio) => (
                      <Grid item md={3} sm={9} xs={12} style={{ marginTop: '10px', marginRight: '20px' }}>
                        <CardVestigio vestigio={vestigio} handleClick={handleClickVestigio} />
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Grid container justifyContent="center" alignItems="center" style={{ padding: '50px' }}>
                    <Typography>Nenhum outro vestígio foi extraído deste</Typography>
                  </Grid>
                )}
              </Grid>

              <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between" md={12} sm={12} xs={12}>
                <Typography className={classes.titleCampo}>
                  <b>ARQUIVOS RELACIONADOS</b>
                </Typography>
                <Grid item md={12} sm={12} xs={12} style={{ padding: '1px' }}>
                  <Divider className={classes.dividerTitle} />
                </Grid>

                {veiculo.arqs?.length ? (
                  <Grid item>
                    <Grid container justifyContent="flex-start" alignItems="center">
                      {veiculo.arqs.map((arquivo) => (
                        <Grid className={classes.item} item md={3} sm={4} xs={8}>
                          <ExibirArquivo id={arquivo.id} rotaLoadFile="/arquivo/veiculo" />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container justifyContent="center" alignItems="center" style={{ padding: '50px' }}>
                    <Typography>Nenhum arquivo relacionado</Typography>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        </div>
      )}
    </Page>
  )
}
